import { SET_LOAD_BOUNTIES } from './actionTypes'

// do I want to put these in the same reducer, the list of items and the selected items?
// is so the initialState = {selected: null, items: []}
// and a SET_LOAD_BOUNTIES would just adjust the items
// and a set selected would adjust the selected.
// or the do both in the setLoad bounties if passing in bounties and selected
// for now let's leave the same pattern and maybe adjust later

const initialState = []

export default (state=initialState,  action) => {
    switch(action.type) {
    case SET_LOAD_BOUNTIES:
        return action.bounties
    default:
        return state
    }
}